<div class="chips-block">
  @for (e of getVisibleItems(data()?.checkbox_acquisitionLangage, langageLabels, 'checkbox_acquisitionLangage'); track e.key) {
  @let daDate = getFirstDate('checkbox_acquisitionLangage', e.key);
  <mat-chip class="chip-small" [class.chip-has-firstda]="daDate"
    #tt="matTooltip"
    [matTooltip]="daDate ? 'Depuis le ' + formatFirstDate(daDate) : ''"
    matTooltipPosition="above"
    (click)="daDate && tt.show()">{{ e.label }}</mat-chip>
  }
</div>
